import React from "react";
import { jsx } from "slate-hyperscript";
import { BlockHandler, ElementType } from "./base";

BlockHandler.register(ElementType.LIST_ITEM, {
    nodeTypes: ["LI"],
    toBlock: child => <li>{child}</li>,
    serialize: child => `<li>${child}</li>`,
    deserialize: children => jsx("element", { type: ElementType.LIST_ITEM }, children),

});
